import React from "react";

/* Shared physical display treatment for every front-facing Steffi render.
 * The outer layer is the recessed black bezel; supplied circular screenshots
 * live inside the same calibrated inset regardless of the page section. */
export default function DeviceScreenFrame({ children, innerBackground = "#eee4d4" }) {
  return (
    <div
      className="relative h-full w-full overflow-hidden rounded-full bg-[#080b0c] p-[4.2%]"
      style={{
        boxShadow:
          "inset 0 0 0 .8cqw rgba(255,255,255,.16), inset 0 0 3cqw rgba(0,0,0,.9)",
      }}
    >
      <div
        className="relative h-full w-full overflow-hidden rounded-full"
        style={{ background: innerBackground }}
      >
        {children}
      </div>

      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 rounded-full"
        style={{
          background:
            "linear-gradient(135deg, rgba(255,255,255,.42) 0%, rgba(255,255,255,.16) 19%, rgba(255,255,255,0) 43%)",
          mixBlendMode: "screen",
          opacity: 0.7,
        }}
      />
    </div>
  );
}
